<template>
  <div class="cartPlainGoldCustom">
    <div
      :class="[
        'cartPlainGoldCustomList',
        cycleCustom.flag === true && flag === true ? 'cartPlainGoldBg' : '',
      ]"
    >
      <div class="outerLayer">
        <el-checkbox
          @change="onChange"
          v-model="cycleCustom.flag"
        ></el-checkbox>
      </div>
      <div class="cartImg">
        <el-image
          :src="cycleCustom[0].product.imgPath"
          @click="goDetaild(cycleCustom[0])"
        >
        </el-image>
        <div class="outStock" v-if="isSoldOut">部分<br />已售</div>
        <div class="outStock" v-if="isDelist">
          已下架
        </div>
      </div>
      <div
        class="cartPlainGoldCustomParameter"
        v-for="(item, index) in cycleCustom"
        :key="index"
      >
        <div class="cartPlainGoldCustomHead" v-if="index === 0">
          <span class="seriesModel">系列</span>
          <span class="cartNumber">款号</span>
          <span class="seriesModel">材质</span>
          <span class="seriesModel">品类</span>
          <span class="seriesModel">金重</span>
          <span class="seriesModel">规格</span>
          <span class="seriesModel">工费</span>
          <span :class="['remkQu']">备注</span>
          <span :class="['remkQu']">商品数量</span>
        </div>
        <div
          v-for="(res, idx) in item.cartList"
          :key="idx"
          :class="['dataContent', res.switchFlag === true ? 'curtBg' : '']"
        >
          <div class="innerLayerSwitch">
            <el-checkbox
              v-if="cycleCustom[0].product.isCouples === '2'"
              v-model="res.switchFlag"
              :disabled="
                cycleCustom[0].totalQuantityFlag === true && res.type === 2
              "
              @change="innerLayer(item)"
            ></el-checkbox>
            <el-checkbox
              v-if="
                cycleCustom[0].product.isCouples === '1' &&
                  res.genderCode === '女'
              "
              v-model="res.switchFlag"
              :disabled="
                cycleCustom[0].type === 2 &&
                  cycleCustom[0].totalFemaleQuantityFlag === true &&
                  res.genderCode === '女'
              "
              @change="innerLayer(item)"
            ></el-checkbox>
            <el-checkbox
              v-if="
                cycleCustom[0].product.isCouples === '1' &&
                  res.genderCode === '男'
              "
              v-model="res.switchFlag"
              :disabled="
                cycleCustom[0].type === 2 &&
                  cycleCustom[0].totalMaleQuantityFlag === true &&
                  res.genderCode === '男'
              "
              @change="innerLayer(item)"
            ></el-checkbox>
          </div>
          <div class="seriesModel">
            {{ cycleCustom[0].product.categoryCodeTwo }}
          </div>
          <div class="cartNumber">{{ res.styleNumber }}</div>
          <div class="seriesModel">{{ res.texture }}</div>
          <div class="seriesModel">{{ item.product.productCategoryName }}</div>
          <div class="seriesModel">
            {{ res.goldWeigh }}
          </div>
          <div class="seriesModel">{{ res.specifications }}</div>

          <div class="seriesModel">
            <span v-if="res.type !== 1">{{ res.sellingLaborCost }}</span>
          </div>
          <div class="seriesModel" v-if="hasMainBodyType()[0].value !== '2'">
            <span v-if="res.type !== 1">{{ res.orderingCycle }}</span>
          </div>
          <div :class="['remkQu']">
            <el-tooltip
              class="item"
              effect="dark"
              :content="res.productRemark"
              placement="bottom"
            >
              <el-button>{{ res.productRemark }}</el-button>
            </el-tooltip>
          </div>
          <div :class="['remkQu', 'reminder']">
            {{ res.quantity
            }}<span
              class="tips"
              v-if="
                cycleCustom[0].type === 2 &&
                  cycleCustom[0].totalQuantityFlag === true &&
                  idx === item.cartList.length - 1 &&
                  cycleCustom[0].product.isCouples === '2'
              "
              >最少定单{{ res.leastQuantity }}件</span
            >
          </div>

          <div
            class="modify"
            v-if="cycleCustom[0].type === 2"
            @click="updateCart(res)"
          >
            修改
          </div>
          <div
            class="deleteCustom"
            v-if="cycleCustom[0].type === 2"
            @click="deleteCart(res)"
          >
            删除
          </div>
        </div>
      </div>
    </div>
    <div class="statusImg">
      <div
        style="padding: 0 6px; height: 32px; line-height: 32px; font-size: 12px; color: #ec9368"
      >
        {{
          ['潮流爆款'].includes(cycleCustom[0].product.productRemark)
            ? '现货'
            : '预订'
        }}
      </div>
    </div>
    <!-- 修改复制弹窗 -->
    <UpdatePlainGold
      v-on="$listeners"
      v-if="plainGoldSelectDialogVisible"
      :plainGoldSelectDialogVisible="plainGoldSelectDialogVisible"
      :modifyingReplication="modifyingReplication"
      @onCloseSelectDialog="onCloseSelectDialog"
    />
    <!-- 删除确认弹窗 -->
    <ConfirmDeletion
      v-if="deletingPopoversVisible"
      :deletingPopoversVisible="deletingPopoversVisible"
      @onCloseSelectDialog="onCloseSelectDialog"
      @confirmDel="confirmDel"
    />
  </div>
</template>
<script>
import { modifyCartPublic } from '@/api/cartApi'
import UpdatePlainGold from '../updata/UpdatePlainGold.vue'
import ConfirmDeletion from '../updata/ConfirmDeletion.vue'
export default {
  name: 'CartPlainGoldCustom',
  props: {
    cycleCustom: {
      type: Array,
      default() {
        return []
      },
    },
    addOrderList: {
      type: Array,
      default() {
        return []
      },
    },
  },
  data() {
    return {
      modifyingReplication: {},
      plainGoldSelectDialogVisible: false,
      deletingPopoversVisible: false,
      flag: false,
      isSoldOut: false, //是否已售
      isDelist: false, //是否下架
    }
  },
  components: {
    ConfirmDeletion,
    UpdatePlainGold,
  },
  watch: {
    cycleCustom: {
      handler(newValue, oldValue) {
        this.totalQuantity()
        this.cycleCustom.forEach((res) => {
          this.flag = res.cartList.every((val) => val.switchFlag == true)
        })
      },
      deep: true, //深度监听数组的变化
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.totalQuantity()
      // 循环未截取的数组找到缺货下架的数据
      this.addOrderList.forEach((res) => {
        if (this.cycleCustom[0]?.id === res[0].id) {
          this.isSoldOut = res[0].cartList.some(
            (ele) => ele.cartStatus === '已售'
          )
          this.isDelist = res[0].cartList.some(
            (ele) => ele.cartStatus === '下架'
          )
        }
      })
    })
  },
  methods: {
    totalQuantity() {
      let totalQuantity = 0
      let totalMaleQuantity = 0
      let totalFemaleQuantity = 0
      this.cycleCustom?.forEach((res) => {
        res.totalQuantityFlag = false
        res.totalMaleQuantityFlag = false
        res.totalFemaleQuantityFlag = false
        res.cartList?.forEach((ele) => {
          if (res.product.isCouples === '2') {
            totalQuantity = Number(totalQuantity) + Number(ele.quantity)
          } else if (res.product.isCouples === '1' && ele.genderCode === '女') {
            totalFemaleQuantity =
              Number(totalFemaleQuantity) + Number(ele.quantity)
          } else if (res.product.isCouples === '1' && ele.genderCode === '男') {
            totalMaleQuantity = Number(totalMaleQuantity) + Number(ele.quantity)
          }
          if (
            (totalQuantity >= ele.leastQuantity && !ele.genderCode) ||
            ele.cartStatus !== '现货'
          ) {
            res.totalQuantityFlag = false
          } else if (!ele.genderCode) {
            res.totalQuantityFlag = true
          }
          if (
            (totalMaleQuantity >= ele.leastQuantity &&
              ele.genderCode === '男') ||
            ele.cartStatus !== '现货'
          ) {
            res.totalMaleQuantityFlag = false
          } else if (ele.genderCode === '男') {
            res.totalMaleQuantityFlag = true
          }
          if (
            (totalFemaleQuantity >= ele.leastQuantity &&
              ele.genderCode === '女') ||
            ele.cartStatus !== '现货'
          ) {
            res.totalFemaleQuantityFlag = false
          } else if (ele.genderCode === '女') {
            res.totalFemaleQuantityFlag = true
          }
          this.$forceUpdate()
        })
      })
    },
    // 跳转详情
    goDetaild(item) {
      this.$router.push({
        path: '/plaingold',
        query: {
          id: item.product.id,
          styleNumber: item.product.styleNumber,
          generaName: item.product.generaName,
          styleFlag: item.type == 1 ? '素金现货' : '素金定单',
        },
      })
    },

    // 修改购物车
    updateCart(res) {
      this.plainGoldSelectDialogVisible = true
      this.modifyingReplication = res
    },
    onCloseSelectDialog() {
      this.plainGoldSelectDialogVisible = false
      this.deletingPopoversVisible = false
    },
    // 删除购物车数据
    deleteCart(res) {
      this.modifyingReplication = res
      this.deletingPopoversVisible = true
    },
    // 确认删除
    confirmDel() {
      let obj = [
        {
          id: this.modifyingReplication.id,
          sequences: [this.modifyingReplication.sequence],
        },
      ]
      modifyCartPublic(obj, 'delete').then((res) => {
        if (res.code === 0) {
          this.$message({
            message: '删除成功',
            type: 'success',
            duration: 1500,
          })
          this.deletingPopoversVisible = false
          this.$emit('updataCart')
        }
      })
    },
    //外层开关
    onChange(value) {
      if (value === true) {
        this.cycleCustom.forEach((res) => {
          res.cartList.forEach((item) => {
            if (item.type === 1 && item.cartStatus === '现货') {
              item.switchFlag = true
            } else if (item.type === 2 && item.cartStatus === '现货') {
              if (
                this.cycleCustom[0].product.isCouples === '2' &&
                this.cycleCustom[0].totalQuantityFlag === false &&
                item.cartStatus === '现货'
              ) {
                item.switchFlag = true
              } else if (
                this.cycleCustom[0].product.isCouples === '1' &&
                item.genderCode === '女' &&
                this.cycleCustom[0].totalFemaleQuantityFlag === false &&
                item.cartStatus === '现货'
              ) {
                item.switchFlag = true
              } else if (
                this.cycleCustom[0].product.isCouples === '1' &&
                item.genderCode === '男' &&
                this.cycleCustom[0].totalMaleQuantityFlag === false &&
                item.cartStatus === '现货'
              ) {
                item.switchFlag = true
              } else {
                item.switchFlag = false
              }
            } else {
              item.switchFlag = false
            }
          })
        })
      } else {
        this.cycleCustom.forEach((res) => {
          res.cartList.forEach((item) => {
            item.switchFlag = false
          })
        })
      }
      this.cycleCustom.forEach((res) => {
        this.flag = res.cartList.every((val) => val.switchFlag == true)
      })
      this.$forceUpdate()
    },
    //内层开关
    innerLayer(item) {
      this.cycleCustom.flag = item.cartList.every(
        (val) => val.switchFlag == true
      )
      this.flag = item.cartList.every((val) => val.switchFlag == true)
    },
  },
}
</script>
<style lang="scss" scoped>
.cartPlainGoldCustom {
  border: 1px solid #ede2ce;
  margin-top: 12px;
  font-size: 14px;
  position: relative;

  .statusImg {
    position: absolute;
    right: 0;
    width: 68px;
    height: 20px;
    top: 0;
    z-index: 0;

    .custom-gold {
      width: 73px;
      height: 20px;
    }

    .pre-sale-shopCart {
      width: 72px;
      height: 24px;
    }
  }

  .cartPlainGoldCustomList {
    display: flex;
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
    white-space: nowrap;

    .outerLayer {
      margin: 10px 7px 0 10px;

      /deep/ .el-checkbox__inner {
        width: 16px;
        height: 16px;
      }

      /deep/.el-checkbox__inner:after {
        height: 9px;
        left: 5px;
        top: 0;
        width: 4px;
      }
    }

    /deep/.el-checkbox__inner:hover {
      border-color: #ec9368;
    }

    /deep/.el-checkbox__input.is-checked .el-checkbox__inner {
      background-color: #ec9368;
      border-color: #ec9368;
    }

    .cartImg {
      min-width: 70px;
      max-width: 70px;
      display: flex;
      align-items: center;
      position: relative;

      /deep/.el-image__inner {
        cursor: pointer;
      }
    }

    .cartPlainGoldCustomParameter {
      text-align: center;
      margin-left: 8px;

      .cartPlainGoldCustomHead {
        display: flex;
        align-items: center;
        margin: 15px 0 0 20px;
      }

      .dataContent:last-child {
        border-bottom: none;
      }

      .dataContent {
        display: flex;
        align-items: center;
        color: #ec9368;
        border-bottom: 1px solid rgb(220, 223, 230);
        padding: 18px 0px;
        height: 34px;

        .innerLayerSwitch {
          width: 20px;
        }
      }

      .curtBg {
        background: rgb(255, 247, 242);
      }

      .seriesModel {
        width: 100px;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-wrap: wrap;
        white-space: break-spaces;

        span {
          height: 16px;
        }

        .el-popover__reference {
          font-size: 12px;
        }
      }

      .cartNumber {
        width: 126px;
      }

      .remkQu {
        width: 78px;

        .el-button {
          width: 100%;
          border: none;
          padding: 0;
          color: #ec9368;
          text-overflow: ellipsis;
          white-space: nowrap;
          overflow: hidden;
        }

        .el-button:focus,
        .el-button:hover {
          background-color: transparent;
        }
      }

      .remkQuActive {
        width: 128px;
      }

      .reminder {
        position: relative;

        .tips {
          color: rgb(255, 0, 0);
          position: absolute;
          left: 50%;
          top: 20px;
          transform: translate(-50%, 0);
          width: 150px;
          font-size: 12px;
        }
      }

      .modify {
        color: #00baff;
        cursor: pointer;
        min-width: 28px;
      }

      .deleteCustom {
        color: #ff0000;
        margin-left: 16px;
        cursor: pointer;
        min-width: 28px;
      }

      .diamondSpotBtn {
        width: 70px;
        text-align: center;
        height: 32px;
        line-height: 32px;
        border: 1px solid #ec9368;
        border-radius: 5px;
        cursor: pointer;
      }

      .question-mark {
        cursor: pointer;
        width: 16px;
        height: 16px;
        margin-left: 3px;
      }
    }
  }

  .cartPlainGoldBg {
    background: rgb(255, 247, 242);
  }
}
</style>
